import { IAppConfiguration } from '../cemexng2components/components/app-configuration';

export default [
  {
    feature: 'credit-request.mx-warranty-type',
    country: ['MX'],
    options: {
      warrantyTypes: [
        {
          creditCatDesc:
            'views.credit-request.credit-collection-instrument-pagare',
          creditCatCode: 'Pagaré'
        },
        {
          creditCatDesc:
            'views.credit-request.credit-collection-instrument-letter',
          creditCatCode: 'Carta de Credito'
        },
        {
          creditCatDesc:
            'views.credit-request.credit-collection-instrument-fondo',
          creditCatCode: 'Fondo de garantía'
        },
        {
          creditCatDesc:
            'views.credit-request.credit-collection-instrument-hipoteca',
          creditCatCode: 'Garantía Hipotecaria'
        },
        {
          creditCatDesc:
            'views.credit-request.credit-collection-instrument-notariado',
          creditCatCode: 'Contrato apertura de credito notariado'
        }
      ]
    }
  }
] as IAppConfiguration[];
